export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_UPDATE_QUANTITIES = 'CART_UPDATE_QUANTITIES';
export const CART_UPDATE_COUPONS = 'CART_UPDATE_COUPONS';
export const CART_REMOVE_COUPONS = 'CART_REMOVE_COUPONS';
export const EMPTY_CART_DETAILS = 'EMPTY_CART_DETAILS';
